import React from 'react';
import { IfmsRoute }from '../../../config/types';
import { LiftingReportView, UsageReportView } from '../../oceanImport/routes';

const routes:Array<IfmsRoute> = [
  { path: '/ams/amsUsageReport', component: UsageReportView },
  { path: '/ams/amsLiftReport', component: LiftingReportView },
  { path: '/ams/amsTotLiftReport', component: LiftingReportView },
  { path: '/ams/aciUsageReport', component: UsageReportView },
];

export default routes;
